<div class="screen">

    <!-- HEADER -->
    <div class="header">
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/blocked-wallet.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Feature not available</div>
  
      <div class="subtitle">
        This account isn't eligible for funding from abroad. Please try another method or contact support for help.
      </div>
    </div>
  
    <!-- BUTTON -->
    <footer class="screen-footer">
      <button
      pButton
      label="OK"
      class="retry-btn"
      (click)="retry()"
    ></button>
    </footer>
  
  </div>
  